import React from 'react'
import MessageChat from '../../components/massageChat/MessageChat'

const Messages = () => {
  return (
    <div className='dashboard-content-box massage-sec'>
      <MessageChat />
    </div>
  )
}

export default Messages
